import { Component, OnInit } from '@angular/core';
import { ContentService } from 'src/app/service/content.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-buildinfo',
  template: `<div class="tw-w-full tw-text-[var(--sed-warm-white-color)]">
    <span class="">{{ appCompany }}</span>
    <span [hidden]="true">
      <br />
      {{ buildInfo }}
    </span>
    <span *ngIf="isDemoMode" class="tw-text-[var(--sed-status-red-color)]"
      >Demo</span
    >
  </div> `,
  styles: [``],
})
export class BuildinfoComponent implements OnInit {
  appCompany: string;
  isDemoMode: boolean;
  version: string;
  buildInfo: string;
  constructor(private contentService: ContentService) {}

  ngOnInit(): void {
    this.version = environment.appVersion;
    this.buildInfo = this.contentService.buildInfo;
    this.appCompany = environment.AppCompany.replace(
      '#YEAR',
      new Date().getFullYear().toString()
    );
    this.isDemoMode = environment.QAMode;
  }
}
